import React from 'react'
import RichTextComponent from '../RichTextComponent/RichTextComponent'

import './MyndOgTexti.scss'

export default function MyndOgTexti(props){
  const {
    slice,
    prismicCtx
  } = props

  return (
    <div className='myndOgTexti__container'>
      <div className='myndOgTexti__texti'>
        <RichTextComponent data={slice.primary.rich_text} prismicCtx={prismicCtx}/>
      </div>
      <img className='myndOgTexti__mynd' src={slice.primary.mynd.url} alt={slice.primary.mynd.alt}/>
    </div>
  )
}